
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeepSourceLogo',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  }
})
